/* eslint-disable no-unused-vars */
import $ from 'jquery';
import Swiper from 'swiper';
import {
    Navigation, Thumbs, Keyboard, A11y,
} from 'swiper/modules';

const siteLanguage = document.querySelector('html').getAttribute('lang');
const translations = {
    en: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}',
        slideLabelMessage: '{{index}} of {{slidesLength}}',
    },
    fr: {
        prevSlideMessage: 'Diapositive précédente',
        nextSlideMessage: 'Diapositive suivante',
        paginationBulletMessage: 'Aller à la diapositive {{index}}',
        slideLabelMessage: '{{index}} sur {{slidesLength}}',
    },
};

const mediaQuery = '(max-width: 1024px)';
const mediaQueryList = window.matchMedia(mediaQuery);

const makeAllButCurrentSlideInert = function makeAllButCurrentSlideInert() {
    const currentSlideEl = this.slides[this.realIndex];
    this.slides.forEach((slide, index) => {
        if (slide !== currentSlideEl) {
            slide.setAttribute('inert', '');
        } else {
            slide.removeAttribute('inert');
        }
    });
};

function createSwiper() {
    const $swiperWrapper = $('.explore-content-swiper-wrapper');
    $swiperWrapper.each((index, element) => {
        const elSwiperContent = element.querySelector('.swiper-content');
        let swiperContent = elSwiperContent.swiper;
        const elSwiperMobileNav = element.querySelector('.swiper-mobile-nav');
        let swiperMobileNav = elSwiperMobileNav.swiper;
        const elSwiperNav = element.querySelector('.swiper-nav');
        let swiperNav = elSwiperNav.swiper;

        // if swiper exists, destroy it so we can create a new one
        if (typeof swiperContent !== 'undefined') {
            swiperContent.destroy(true, true);
        }
        if (mediaQueryList.matches) {
            if (typeof swiperNav !== 'undefined') {
                swiperNav.destroy(true, true);
            }
            swiperMobileNav = new Swiper(elSwiperMobileNav, {
                modules: [Thumbs, Keyboard, A11y],
                spaceBetween: 5,
                slidesPerView: 4,
                keyboard: {
                    enabled: true,
                },
                breakpoints: {
                    540: {
                        slidesPerView: 5,
                    },
                    768: {
                        spaceBetween: 10,
                    },
                },
            });
            swiperContent = new Swiper(elSwiperContent, {
                modules: [Navigation, Thumbs, Keyboard, A11y],
                a11y: {
                    enabled: true,
                    prevSlideMessage: `${translations[siteLanguage].prevSlideMessage}`,
                    nextSlideMessage: `${translations[siteLanguage].nextSlideMessage}`,
                    paginationBulletMessage: `${translations[siteLanguage].nextSlideMessage}`,
                    slideLabelMessage: `${translations[siteLanguage].nextSlideMessage}`,
                },
                keyboard: {
                    enabled: true,
                },
                slidesPerView: 1,
                navigation: {
                    nextEl: document.querySelector('.swiper-nav-container-mobile .slider-button-next'),
                    prevEl: document.querySelector('.swiper-nav-container-mobile .slider-button-prev'),
                },
                thumbs: {
                    swiper: swiperMobileNav,
                },
                on: {
                    init() {
                        makeAllButCurrentSlideInert.call(this);
                    },
                    slideChange() {
                        makeAllButCurrentSlideInert.call(this);
                    },
                },
            });
        } else {
            if (typeof swiperMobileNav !== 'undefined') {
                swiperMobileNav.destroy(true, true);
            }
            swiperNav = new Swiper(elSwiperNav, {
                modules: [Thumbs, Keyboard, A11y],
                direction: 'vertical',
                spaceBetween: 10,
                slidesPerView: 5,
                keyboard: {
                    enabled: true,
                },
            });
            swiperContent = new Swiper(elSwiperContent, {
                modules: [Navigation, Thumbs, Keyboard, A11y],
                a11y: {
                    enabled: true,
                    prevSlideMessage: `${translations[siteLanguage].prevSlideMessage}`,
                    nextSlideMessage: `${translations[siteLanguage].nextSlideMessage}`,
                    paginationBulletMessage: `${translations[siteLanguage].nextSlideMessage}`,
                    slideLabelMessage: `${translations[siteLanguage].nextSlideMessage}`,
                },
                slidesPerView: 1,
                direction: 'vertical',
                keyboard: {
                    enabled: true,
                },
                navigation: {
                    nextEl: document.querySelector('.swiper-nav-container .slider-button-next'),
                    prevEl: document.querySelector('.swiper-nav-container .slider-button-prev'),
                },
                thumbs: {
                    swiper: swiperNav,
                },
                on: {
                    init() {
                        makeAllButCurrentSlideInert.call(this);
                    },
                    slideChange() {
                        makeAllButCurrentSlideInert.call(this);
                    },
                    slideChangeTransitionEnd() {
                        const currentSlideEl = this.slides[this.realIndex];
                    },
                },
            });
        }
    });
}
if (document.querySelector('.explore-content-swiper-wrapper')) {
    createSwiper();
    mediaQueryList.addEventListener('change', (event) => {
        createSwiper();
    });
}
